<template lang="pug">
  div.view-z.flex-row.align-items-center
    div.container
      div.row.justify-content-center
        div.col-md-6
          b-card.shadow-lg.rounded.theme-glass
            div.p-4
              div.d-flex.flex-row.align-items-baseline
                h1 {{ $t("ui.combine.first_time_login") }}
              b-form.form-signin(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.icon-user
                  DebounceInput(
                    required
                    ref="username"
                    type="text"
                    v-model.trim.lazy="$v.username.$model"
                    :placeholder='$t("ui.username")'
                    :disabled="loading"
                    :maxLength="$v.username.$params.maxLength.max"
                    :dirty="$v.username.$dirty"
                    :error="$v.username.$error"
                    )
                ValidateResult(:value="$v.username" :name="$t('ui.username')")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.icon-lock
                  DebounceInput(
                    required
                    autocomplete="section-red current-password"
                    type="password"
                    v-model.trim.lazy="$v.password.$model"
                    :placeholder='$t("ui.password")'
                    :disabled="loading"
                    :maxLength="$v.password.$params.maxLength.max"
                    :dirty="$v.password.$dirty"
                    :error="$v.password.$error"
                    )
                ValidateResult(:value="$v.password" :name="$t('ui.password')")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.icon-lock
                  DebounceInput(
                    required
                    autocomplete="section-red current-password"
                    type="password"
                    v-model.trim.lazy="$v.confirm_password.$model"
                    :placeholder='$t("ui.combine.confirm_password")'
                    :disabled="loading"
                    :dirty="$v.confirm_password.$dirty"
                    :error="$v.confirm_password.$error"
                    )
                ValidateResult(:value="$v.confirm_password" :name="$t('ui.combine.confirm_password')" :name2="$t('ui.password')")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.fas.fa-tag
                  DebounceInput(
                    required
                    type="text"
                    v-model.trim.lazy="$v.security_tag.$model"
                    :placeholder='$t("ui.security_tag")'
                    :disabled="loading"
                    :maxLength="$v.security_tag.$params.maxLength.max"
                    :dirty="$v.security_tag.$dirty"
                    :error="$v.security_tag.$error"
                    )
                ValidateResult(:value="$v.security_tag" :name="$t('ui.security_tag')")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.fas.fa-tag
                  DebounceInput(
                    required
                    type="password"
                    v-model.trim.lazy="$v.security_code.$model"
                    :placeholder='$t("ui.security_code")'
                    :disabled="loading"
                    :maxLength="$v.security_code.$params.maxLength.max"
                    :dirty="$v.security_code.$dirty"
                    :error="$v.security_code.$error"
                    )
                ValidateResult(:value="$v.security_code" :name="$t('ui.security_code')")
                b-input-group
                  b-input-group-text(slot="prepend")
                    i.fas.fa-tag
                  DebounceInput(
                    required
                    type="password"
                    v-model.trim.lazy="$v.confirm_security_code.$model"
                    :placeholder='$t("ui.combine.confirm_security_code")'
                    :disabled="loading"
                    :dirty="$v.confirm_security_code.$dirty"
                    :error="$v.confirm_security_code.$error"
                    )
                ValidateResult(:value="$v.confirm_security_code" :name="$t('ui.combine.confirm_security_code')" :name2="$t('ui.security_code')")
                div.row
                  div.col
                    b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
                div.row
                  div.col.text-right.mt-2
                    SubmitButton.btn-login(icon="fa fa-save" :text="$t('ui.save')" variant="secondary" size="lg" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, sameAs, alphaNum } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      username: "",
      password: "",
      confirm_password: "",
      security_tag: "",
      security_code: "",
      confirm_security_code: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/login"
    };
  },
  validations: {
    username: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(20),
      alphaNum
    },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    confirm_password: {
      required,
      sameAs: sameAs("password")
    },
    security_tag: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    security_code: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    confirm_security_code: {
      required,
      sameAs: sameAs("security_code")
    }
  },
  mounted: function() {
    this.$refs.username.$el.focus();
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
    },
    submit: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let new_username = this.username;
        let new_password = this.password;
        let security_tag = this.security_tag
        let security_code = this.security_code
        this.loading = true;
        this.$store
          .dispatch("user/firstTime", { new_username, new_password, security_tag, security_code })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.status;
            if (this.submission.success == true) {
              this.$router.push(this.redirect);
              // this.$swal({
              //   title: this.$t("ui.success"),
              //   text: this.$t("message.successful_create_secondary_account"),
              //   type: "success"
              // }).then(isConfirm => {
              //   if (isConfirm) {
              //     this.$router.push(this.redirect);
              //   }
              // });
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            // this.submission.status =  response.status;
            this.submission.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  color: #ffffff;
}

p {
  color: rgba(255, 255, 255, 0.5);
}

.card {
  margin-bottom: 0 !important;
  // background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

// .btn-login,
// .btn-login:hover {
//   border: 1px solid rgba(0, 0, 0, 0.75);
//   background: #f29941;
//   background: -moz-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: -webkit-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: linear-gradient(to bottom, #f29941 0%, #e8455d 100%);
//   color: #ffffff;
//   box-shadow: 0 0 16px rgba(255, 255, 255, 0.25);
// }

.input-group-text {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input {
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: rgba(0, 255, 255, 0.5);
  padding-right: 1.875rem;
  background-repeat: no-repeat;
  background-position: center right calc(1.875rem / 4);
  background-size: calc(1.875rem / 2) calc(1.875rem / 2);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300ffff' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

input.is-valid {
  border: 1px solid rgba(0, 255, 255, 0.5);
}

input.is-invalid {
  border: 1px solid rgba(255, 0, 0, 0.5);
}

::placeholder {
  color: black;
  font-weight: normal;
  opacity: 1;
}
</style>
